import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
// import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { IconButton, Stack, SvgIcon } from '@mui/material';
import { ReactComponent as TuiLogo } from '../tuilogo.svg';
import { useAuth } from '../hooks/useAuth';
import { useCallback, useEffect, useState } from 'react';
import SettingsMenu from './SettingsMenu';
import { ReactComponent as MenuIcon } from '../icons/menu.svg';
// import { ReactComponent as MenuIcon } from '../icons/menu.svg';

export interface IHeaderProps {
  title: string,
  handleDrawerToggle?: () => void;
}

function Header(props: IHeaderProps) {
  const auth = useAuth();
  const [username, setUsername] = useState<string>('');
  const { handleDrawerToggle, title } = props;

  const getUserInfo = useCallback(async () => {
    let user = await auth?.getUser();

    if(user === undefined)
      setUsername('(Unkown)');
    else {
      let name = user.firstname !== undefined ? `${user.surname}, ${user.firstname}` : user.username ?? 'Unkown';
      setUsername(name);
    }
      
  }, [auth]);
  useEffect(() => {
    getUserInfo();
  }, [getUserInfo])

  return (
    <AppBar
      position="fixed"
    >
      <Toolbar>
        <SvgIcon component={TuiLogo} inheritViewBox sx={{ display: { xs: 'none', md: 'flex' }, mr: 2, mt: -0.5, width: 60, height: 30 }} />
        <Typography
          noWrap
          component="h1"
          sx={{
            mr: 2,
            display: { xs: 'none', md: 'flex' },
            mt: 0.8,
            color: 'inherit',
            textDecoration: 'none',
            flexGrow: 1,
            fontWeight: 'bold',
          }}
        >
          {title}
        </Typography>
        <Box sx={{ flexGrow: 1, ml: -1, display: { xs: 'flex', md: 'none' } }}>
          <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleDrawerToggle}
              color="inherit"
            >
              <SvgIcon component={MenuIcon} inheritViewBox />
            </IconButton>
        </Box>
        <SvgIcon component={TuiLogo} inheritViewBox sx={{ display: { xs: 'flex', md: 'none' }, mr: 2, mt: -1.1, width: 60, height: 30 }} />
        <Typography
          noWrap
          component="h1"
          sx={{
            mr: 2,
            display: { xs: 'flex', md: 'none' },
            flexGrow: 1,
            color: 'inherit',
            textDecoration: 'none',
            fontWeight: 'bold',
          }}
        >
          {title}
        </Typography>

        <Box sx={{ flexGrow: 0 }}>
          <Stack spacing={2} direction="row">
            <div>{username}</div>
            <SettingsMenu />
          </Stack>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
export default Header;